<template>
  <b-modal
    v-model="showModal"
    size="lg"
    title-class="font-18"
    title="Aceite de Proposta de Admissão"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div class="d-flex justify-content-center">
      <div class="col-md-12 card">
        <div class="card-body">
          <div class="row">
            <h6 class="mt-3 mb-3 font-bold">
              Sua filiação junto a cooperativa foi liberada!
            </h6>
            <h6 class="mb-3 font-bold">
              Agora você precisa realizar o processo de aceite da Proposta de
              Admissão. Porém, antes de assiná-la eletronicamente é necessário
              fazer a leitura dos seguintes documentos:
            </h6>
            <h6 class="mb-3 font-bold">
              <i class="mdi mdi-arrow-right-circle font-size-15"></i>
              <a
                href="https://uniweb.unicampo.coop.br/uniweb/Content/Documentos/Geral/EstatutoSocial.pdf"
                target="_blank"
              >
                Estatuto Social</a
              >
              <br />
              <i class="mdi mdi-arrow-right-circle font-size-15"></i>
              <a
                href="https://unicampo.coop.br/uploads/arquivos/compliance/manual_do_cooperado.pdf"
                target="_blank"
              >
                Materiais de Compliance
              </a>
            </h6>
          </div>
          <div class="row mb-2">
            <div class="m-auto">
              <b-form-radio
                v-model="opcaoAceite"
                :value="true"
                :name="'opcaoAceite'"
                plain
                :disabled="disableAceito"
              >
                Estou de acordo com o Estatuto Social e Materiais de Compliance.
                Aceito, por LIVRE e ESPONTÂNEA VONTADE, sem a interferência ou
                indução de qualquer pessoa ou a existência de determinado
                projeto ou posto de trabalho disponível, o ingresso na
                COOPERATIVA DE TRABALHO DOS PROFISSIONAIS DE AGRONOMIA LTDA.
                UNICAMPO na qualidade de sócio cooperado.
              </b-form-radio>
            </div>
          </div>
          <div class="row mb-2">
            <div class="m-auto">
              <b-form-radio
                v-model="opcaoAceite"
                :value="false"
                :name="'opcaoAceite'"
                plain
              >
                Não aceito.
              </b-form-radio>
            </div>
          </div>
          <div class="row">
            <div class="mt-5 d-flex justify-content-end">
              <b-button
                variant="success"
                class="mt-1 me-1"
                :disabled="!opcaoAceite"
                @click="aceitar"
                data-tooltip="Aceitar"
                data-tooltip-location="bottom"
              >
                Aceitar
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      opcaoAceite: false,
      disableAceito: false,
    };
  },

  methods: {
    abrirModal() {
      this.$store.commit("ACEITE_FILIACAO", false);
      this.showModal = true;
    },

    updateValues() {
      if (this.nAceito === true) {
        this.aceito = false;
        this.estouDeAcordo = false;
        this.disableAceito = true;
      } else {
        this.disableAceito = false;
        return;
      }
    },

    aceitar() {
      this.$store.commit("ACEITE_FILIACAO", true);
      this.showModal = false; // Isso irá fechar o modal
    },
  },
};
</script>